import { FormEvent, useRef, useState } from 'react';
import { errorMessage, httpStatus, platformApi } from './client';
import { AuthFailure, ResourceState, SectionHeading, useResource } from './shared';

interface HeadquartersBank {
  bank_name: string; bank_num: string; depositor: string; revision: string; temporary: boolean;
}
export function HeadquartersBankAccount({ onAuth }: { onAuth: AuthFailure }) {
  const state = useResource<HeadquartersBank>('/headquarters-bank-account', onAuth);
  const [notice, setNotice] = useState('');
  return <section className="pa-card">
    <SectionHeading title="본사 PG 수납 계좌" description="본사가 PG 대금을 받는 계좌입니다. 무통장 주문은 셀러가 등록한 계좌로 직접 입금됩니다." />
    {notice && <p role="status" className="pa-success">{notice}</p>}
    <ResourceState {...state} retry={state.reload}>{state.data && <BankForm key={state.data.revision} account={state.data} onAuth={onAuth} reload={state.reload} saved={() => { setNotice('본사 수납 계좌를 저장했습니다.'); state.reload(); }} />}</ResourceState>
  </section>;
}
function BankForm({ account, onAuth, reload, saved }: { account: HeadquartersBank; onAuth: AuthFailure; reload: () => void; saved: () => void }) {
  const [form, setForm] = useState({ bank_name: account.bank_name || '', bank_num: account.bank_num || '', depositor: account.depositor || '' });
  const [busy, setBusy] = useState(false), [error, setError] = useState(''), [conflict, setConflict] = useState(false);
  const lock = useRef(false);
  const submit = async (event: FormEvent) => {
    event.preventDefault(); if (lock.current || conflict) return;
    lock.current = true; setBusy(true); setError('');
    try {
      await platformApi.patch('/headquarters-bank-account', { ...form, revision: account.revision });
      saved();
    } catch (failure) {
      const status = httpStatus(failure); if (status === 401 || status === 403) onAuth(status);
      setError(errorMessage(failure)); setConflict(status === 409);
    } finally { lock.current = false; setBusy(false); }
  };
  return <form className="pa-status-form" aria-label="본사 수납 계좌 입력" onSubmit={submit}>
    {account.temporary && <p className="pa-finance-help">임시 계좌입니다. 실제 본사 PG 수납 계좌로 수정해주세요.</p>}
    <div className="pa-finance-fields">
      <label>본사 수납 은행<input required disabled={busy} maxLength={80} value={form.bank_name} onChange={event => setForm({ ...form, bank_name: event.target.value })} /></label>
      <label>본사 수납 계좌번호<input required disabled={busy} inputMode="numeric" pattern="(?=.*[0-9])[0-9\-]{4,50}" maxLength={50} value={form.bank_num} onChange={event => setForm({ ...form, bank_num: event.target.value })} /></label>
      <label>본사 수납 예금주<input required disabled={busy} maxLength={100} value={form.depositor} onChange={event => setForm({ ...form, depositor: event.target.value })} /></label>
    </div>
    {error && <p role="alert" className="pa-inline-error">{error}{conflict && <button type="button" className="pa-text-button" onClick={reload}>최신 본사 계좌 불러오기</button>}</p>}
    <div className="pa-finance-actions"><button type="submit" className="pa-button pa-button-primary" disabled={busy || conflict}>{busy ? '저장 중…' : '본사 수납 계좌 저장'}</button></div>
  </form>;
}
